import { useState } from "react";
import useClientes from "../../hooks/useClientes";
import ModalDetalhesCliente from "../../components/cliente/ModalDetalhesCliente";
import ModalHistoricoCliente from "../../components/cliente/ModalHistoricoCliente";
import ModalHistoricoFinanceiro from "../../components/financeiro/ModalHistoricoFinanceiro";
import ModalProntuarioCliente from "../../components/cliente/ModalProntuarioCliente"; // <-- NOVO IMPORT
import {
  aplicarMascaraCPF,
  formatarNomeUpper,
  aplicarMascaraTelefone
} from "../../utils/formatadores";

const Clientes = () => {
  const { clientes, buscarCliente, atualizarCliente } = useClientes();
  const [busca, setBusca] = useState("");
  
  // Controle de estados dos Modais
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [abrirModalDetalhes, setAbrirModalDetalhes] = useState(false);
  const [abrirHistoricoCliente, setAbrirHistoricoCliente] = useState(false);
  const [abrirHistoricoFinanceiro, setAbrirHistoricoFinanceiro] = useState(false);
  const [abrirProntuarioCliente, setAbrirProntuarioCliente] = useState(false); // <-- NOVO ESTADO

  // Filtro de busca
  const clientesExibidos = busca.trim() ? buscarCliente(busca) : clientes;

  const handleSelecionarCliente = (cliente) => {
    setClienteSelecionado(cliente);
    setAbrirModalDetalhes(true);
  };

  const handleFecharModais = () => {
    setClienteSelecionado(null);
    setAbrirModalDetalhes(false);
    setAbrirHistoricoCliente(false);
    setAbrirHistoricoFinanceiro(false);
    setAbrirProntuarioCliente(false); // <-- ATUALIZADO
  };

  const handleAtualizarEAtualizarEstado = async (dadosAtualizados) => {
    const res = await atualizarCliente(dadosAtualizados);
    if (res?.success && res.data) {
      setClienteSelecionado(res.data);
    }
    return res;
  };

  return (
    <div className="container">
      <div className="card">
        <h1>CLIENTES</h1>

        {/* BARRA DE BUSCA */}
        <div className="search-inline">
          <input
            type="text"
            placeholder="Buscar por Nome ou CPF..."
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
        </div>

        {/* TABELA DE CLIENTES */}
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>Telefone</th>
              </tr>
            </thead>
            <tbody>
              {clientesExibidos.length > 0 ? (
                clientesExibidos.map((cliente) => {
                  const nomeOriginal = cliente.nomeCliente || cliente.nome;

                  return (
                    <tr
                      key={cliente._id}
                      onClick={() => handleSelecionarCliente(cliente)}
                      className="row-hover cursor-pointer"
                    >
                      <td>
                        {nomeOriginal
                          ? formatarNomeUpper(nomeOriginal)
                          : "Não informado"}
                      </td>
                      <td>{aplicarMascaraCPF(cliente.cpf) || "Não informado"}</td>
                      <td>{aplicarMascaraTelefone(cliente.telefone) || "Não informado"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3" className="text-center empty-cell">
                    Nenhum cliente encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL 1: DETALHES E EDIÇÃO DO CLIENTE */}
      {abrirModalDetalhes && clienteSelecionado && (
        <ModalDetalhesCliente
          cliente={clienteSelecionado}
          onClose={handleFecharModais}
          onAtualizarCliente={handleAtualizarEAtualizarEstado}
          onAbrirHistoricoCliente={() => setAbrirHistoricoCliente(true)}
          onAbrirHistoricoFinanceiro={() => setAbrirHistoricoFinanceiro(true)}
          onAbrirProntuarioCliente={() => setAbrirProntuarioCliente(true)} // <-- NOVA PROP
        />
      )}

      {/* MODAL 2: HISTÓRICO DE PROCESSOS DO CLIENTE */}
      {abrirHistoricoCliente && clienteSelecionado && (
        <ModalHistoricoCliente
          cliente={clienteSelecionado}
          onClose={() => setAbrirHistoricoCliente(false)}
        />
      )}

      {/* MODAL 3: HISTÓRICO FINANCEIRO DO CLIENTE */}
      {abrirHistoricoFinanceiro && clienteSelecionado && (
        <ModalHistoricoFinanceiro
          cliente={clienteSelecionado}
          onClose={() => setAbrirHistoricoFinanceiro(false)}
        />
      )}

      {/* MODAL 4: PRONTUÁRIO DO CLIENTE */}
      {abrirProntuarioCliente && clienteSelecionado && (
        <ModalProntuarioCliente
          cliente={clienteSelecionado}
          onClose={() => setAbrirProntuarioCliente(false)}
        />
      )}
    </div>
  );
};

export default Clientes;